var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Loader } from '../../utils/Loader';
import * as ServiceDashboard from '../../services/dashboard';
import { ChartBar } from './ChartBar';
import { useEffect, useState } from 'react';
import { CardTitle } from '../../utils/CardTitle';
import { Grid } from '@mui/material';
import { getColors } from '../../utils/Classes';
import { Typography } from '../../utils/Typography';
import { SignatureIcon, AddIcon } from '../../utils/Icons';
export var Dynamique = function (_a) {
    var Debut = _a.Debut, Fin = _a.Fin, GroupeId = _a.GroupeId, CollaborateurIds = _a.CollaborateurIds;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState({}), datas = _c[0], setDatas = _c[1];
    var colors = getColors();
    useEffect(function () {
        var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, ServiceDashboard.getDynamique({
                                DateDebut: Debut,
                                DateFin: Fin,
                                GroupeId: GroupeId,
                                CollaborateurIds: CollaborateurIds,
                            })];
                    case 1:
                        data = _a.sent();
                        data.Realise = data.Realise.map(function (item) {
                            item.tooltip = [
                                { name: 'Tarif', value: item.TotalTarif },
                                { name: 'Marge', value: item.TotalMarge },
                                { name: 'Objectif tarif', value: item.TotalObjectifTarif },
                                { name: 'Objectif marge', value: item.TotalObjectifMarge },
                            ];
                            return item;
                        });
                        data.Creation = data.Creation.map(function (item) {
                            item.tooltip = [
                                { name: 'Tarif', value: item.TotalTarif },
                                { name: 'Marge', value: item.TotalMarge },
                                { name: 'Objectif tarif', value: item.TotalObjectifCreation },
                            ];
                            return item;
                        });
                        data.Portefeuille = data.Portefeuille.map(function (item) {
                            item.tooltip = [
                                { name: 'Tarif', value: item.TotalTarif },
                                { name: 'Marge', value: item.TotalMarge },
                                { name: 'Objectif tarif', value: item.TotalObjectifPortefeuille },
                            ];
                            return item;
                        });
                        setDatas(data);
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        getData();
    }, [Debut, Fin, GroupeId, CollaborateurIds]);
    var renderContent = function () {
        var Realise = datas.Realise, Portefeuille = datas.Portefeuille, Creation = datas.Creation;
        return (_jsxs(Grid, __assign({ container: true, spacing: 2, paddingX: 2, className: "mt-xsmall" }, { children: [_jsxs(Grid, __assign({ item: true, xs: 12 }, { children: [_jsx(CardTitle, { color: "affaire", title: _jsx(Typography, __assign({ startIcon: _jsx(SignatureIcon, {}) }, { children: "Affaires valid\u00E9es" })) }), _jsx(ChartBar, { datas: Realise, config: [
                                {
                                    label: 'Objectif tarif',
                                    name: 'TotalObjectifTarif',
                                    color: colors.secondary.main,
                                    type: 'line',
                                },
                                {
                                    label: 'Objectif marge',
                                    name: 'TotalObjectifMarge',
                                    color: colors.secondary.light,
                                    type: 'line',
                                },
                                {
                                    label: 'Marge',
                                    name: 'TotalMarge',
                                    color: colors.success.dark,
                                    type: 'bar',
                                },
                                {
                                    label: 'Tarif',
                                    name: 'TotalTarif',
                                    color: colors.success.main,
                                    type: 'bar',
                                },
                            ], isEuro: true })] })), _jsxs(Grid, __assign({ item: true, xs: 12 }, { children: [_jsx(CardTitle, { color: "secondary", title: _jsx(Typography, __assign({ startIcon: _jsx(SignatureIcon, {}) }, { children: "Affaires en cours" })) }), _jsx(ChartBar, { datas: Portefeuille, config: [
                                {
                                    label: 'Objectif',
                                    name: 'TotalObjectifPortefeuille',
                                    color: colors.secondary.main,
                                    type: 'line',
                                },
                                {
                                    label: 'Marge',
                                    name: 'TotalMarge',
                                    color: colors.success.dark,
                                    type: 'bar',
                                },
                                {
                                    label: 'Tarif',
                                    name: 'TotalTarif',
                                    color: colors.success.main,
                                    type: 'bar',
                                },
                            ], isEuro: true })] })), _jsxs(Grid, __assign({ item: true, xs: 12 }, { children: [_jsx(CardTitle, { color: "secondary", title: _jsx(Typography, __assign({ startIcon: _jsx(AddIcon, {}) }, { children: "Affaires cr\u00E9\u00E9es" })) }), _jsx(ChartBar, { datas: Creation, config: [
                                {
                                    label: 'Objectif',
                                    name: 'TotalObjectifCreation',
                                    color: colors.secondary.main,
                                    type: 'line',
                                },
                                {
                                    label: 'Marge',
                                    name: 'TotalMarge',
                                    color: colors.success.dark,
                                    type: 'bar',
                                },
                                {
                                    label: 'Tarif',
                                    name: 'TotalTarif',
                                    color: colors.success.main,
                                    type: 'bar',
                                },
                            ], isEuro: true })] }))] })));
    };
    return loading ? _jsx(Loader, {}) : renderContent();
};
//# sourceMappingURL=Dynamique.js.map